import { Dictionary } from '@ngrx/entity';
import { createAction, props } from '@ngrx/store';
import { FieldsState, SearchableData, SortDirectionType } from '../../models';

export const DataFilterAction = {
  setDataForFiltering: createAction(
    '[Data filter] set data',
    props<{ instanceId: string; data: any[]; shouldSetPredefinedSearchValue: boolean }>(),
  ),
  dataFiltered: createAction('[Data filter] data filtered', props<{ instanceId: string; data: any[] }>()),
  init: createAction('[Data filter] init', props<{ instanceId: string; queryParamsDisabled: boolean; loadingState: { [key: string]: boolean } }>()),
  definitionStateBuilt: createAction(
    '[Data filter] definition state built',
    props<{
      instanceId: string;
      definitionState: FieldsState;
      dataDictionary: Dictionary<any>,
      orderedDataIds: string[],
      sortOptionId: string,
      sortDirection: SortDirectionType,
      searchableData: Dictionary<SearchableData>,
      searchedValue: string
    }>()
  ),
  destroy: createAction('[Data filter] destroy', props<{ instanceId: string }>()),

  /**
   * Forces filter's system to recalculate filtered items
   */
  forceCalculation: createAction('[Data filter] force items filtering', props<{ instanceId: string }>()),

  /** Toggles options. Accepts instance id and options data dictionary, where:
   * - Key is field id
   * - Value is array of options need to be toggled
   */
  toggleOptions: createAction(
    '[Data filter] toggle options',
    props<{ instanceId: string; optionsData: { [fieldId: string]: string[] }; fieldName?: string }>()
  ),

  /** Selects options. Accepts instance id and options data dictionary, where:
   * - Key is field id
   * - Value is array of options need to be toggled
   */
  selectOptions: createAction(
    '[Data filter] select options',
    props<{ instanceId: string; optionsData: { [fieldId: string]: string[] }; fieldName?: string }>()
  ),

  /** Unselects options. Accepts instance id and options data dictionary, where:
   * - Key is field id
   * - Value is array of options need to be toggled
   */
  unSelectOptions: createAction(
    '[Data filter] unselect options',
    props<{ instanceId: string; optionsData: { [fieldId: string]: string[] } }>()
  ),

  /** Sets options. Accepts instance id and options data dictionary, where:
   * - Key is field id
   * - Value is array of options to be set
   */
  setOptions: createAction(
    '[Data filter] set options',
    props<{ instanceId: string; optionsData: { [fieldId: string]: string[] } }>()
  ),

  resetFields: createAction('[Data filter] reset options', props<{ instanceId: string; fieldIds: string[] }>()),
  reset: createAction('[Data filter] reset', props<{ instanceId: string }>()),
  resetSearch: createAction('[Data filter] reset search', props<{ instanceId: string }>()),
  search: createAction('[Data filter] search', props<{ instanceId: string, searchValue: string }>()),
  toggleSortDirection: createAction('[Data filter] toggle sort direction', props<{ instanceId: string }>()),
  changeSortOption: createAction('[Data filter] change sort option', props<{ instanceId: string, sortOptionId: string, sortDirection?: SortDirectionType }>()),
  sortingFinished: createAction('[Data filter] sorting finished', props<{ instanceId: string, sortOptionId: string, sortedIds: string[], sortDirection?: SortDirectionType }>()),
  fieldDataLoaded: createAction('[Data filter definition] Data for field loaded', props<{ instanceId: string, fieldId: string }>()),
};
